<template>
  <div class="map-editor-history" v-if="editorState.history.length">
    <div class="map-editor-history__header">
      <div
        @click="editorHistoryShow = !editorHistoryShow"
        class="map-editor-history__title"
      >
        История изменений
        <i
          :class="
            editorHistoryShow ? 'el-icon-caret-bottom' : 'el-icon-caret-right'
          "
        ></i>
      </div>
      <div v-if="editorHistoryShow" class="map-editor-history__buttons">
        <el-tooltip
          :open-delay="1000"
          effect="dark"
          content="Назад"
          placement="top"
        >
          <el-button
            :disabled="editorState.historyIndex === 0"
            class="r-button icon-button"
            size="mini"
            icon="el-icon-arrow-left"
            type="primary"
            circle
            plain
            @click="changeHistoryStep('dec')"
          />
        </el-tooltip>
        <el-tooltip
          :open-delay="1000"
          effect="dark"
          content="Вперед"
          placement="top"
        >
          <el-button
            :disabled="
              editorState.historyIndex === editorState.history.length - 1
            "
            class="r-button icon-button"
            size="mini"
            icon="el-icon-arrow-right"
            type="primary"
            circle
            plain
            @click="changeHistoryStep('inc')"
          />
        </el-tooltip>
        <el-tooltip
          :open-delay="1000"
          effect="dark"
          content="Очистить изменения"
          placement="top"
        >
          <el-button
            size="mini"
            class="r-button icon-button"
            type="danger"
            circle
            plain
            @click="clearEditingState"
          >
            <r-icon name="trash" :size="14" />
          </el-button>
        </el-tooltip>
      </div>
    </div>
    <div v-if="editorHistoryShow" class="map-editor-history__container">
      <div
        :class="[
          'map-editor-history__item',
          i === editorState.historyIndex ? 'active' : ''
        ]"
        @click="changeHistoryStep(i)"
        v-for="(item, i) in editorState.history"
        :key="item.id"
      >
        {{ i + 1 }} - {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["editor-state"],
  data() {
    return {
      editorHistoryShow: true
    };
  },
  methods: {
    changeHistoryStep(i) {
      this.$emit("change-history-step", i);
    },
    clearEditingState() {
      this.$emit("clear-editing-state");
    }
  }
};
</script>

<style lang="scss">
.map-editor-history {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
  }
  &__title {
    line-height: 28px;
    cursor: pointer;
    font-size: 12px;
    color: var(--text_secondary) !important;
  }

  &__buttons {
    display: flex;
    justify-content: flex-end;

    .r-button.icon-button.is-circle {
      padding: 4px !important;
    }
  }

  &__container {
    padding: 5px;
    border-radius: var(--border-radius);
    border: 1px solid transparent;
    border-color: var(--dividers_low_contrast) !important;
    background-color: var(--bg_panel_primary) !important;
  }
  &__item {
    font-size: 11px;
    cursor: pointer;
    color: var(--text_secondary) !important;

    &.active {
      font-weight: bold;
      font-size: 12px;
    }
    &:not(:first-child) {
      margin-top: 5px;
    }
  }
}
</style>
